<div class="modal-body">
    <div class="modal-title">
        <div class="hd-icon hd-icon-sendscript"></div>
        <div class="title">
            <span>{{'sendScript_Title' | xsI18n }}</span>
        </div>
        <div class="xs-dialog-close-btn" [soti-tooltip]="'lv-close' | xsI18n" placement="top" (click)="cancel()"></div>
    </div>
    <div class="dialog-header-separator"></div>
    <div class="body-container">
        <div class="left-panel">
            <ul>
                <li (click)="onSelectItem(item)" *ngFor="let item of selectList" [ngClass]="{ 'selectedItem' : selectedItem.id === item.id }">
                    <div [ngClass]="{ 'italicItem' : item.italic }">
                        <span>{{item.caption}}</span>
                    </div>
                </li>
            </ul>
        </div>
        <div class="right-panel">
            <div class="script-description">
                {{'sendScript_Description' | xsI18n }}
            </div>
            <div class="script-editor">
                <span class="execute-script-textarea-title">{{'sendScript_TextAreaTitle' | xsI18n }}</span>
                <textarea [(ngModel)]="currentScript" class="execute-script-textarea" sa-autofocus></textarea>
            </div>
            <div class="script-footer-warning">
                {{'sendScript_Warning' | xsI18n }}
            </div>
            <div class="right-aligned-buttons">
                <button class="xs-btn btn-outline btn-space" (click)="cancel()">{{'xs_cancel_label' | xsI18n }}</button>
                <button class="xs-btn btn-primary" title="Send Script" (click)="send()" [attr.disabled]="isDisabled() ? '' : null">{{'sendScript_SendButton' | xsI18n }}</button>
            </div>
        </div>
    </div>
</div>